const getKey = ({digitalSignId, layoutId, sceneId}) => `${digitalSignId}.${layoutId}.${sceneId}`;
export default getKey;
